"use strict";

var _toConsumableArray = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jss = require("jss");
var _jssRtl = _interopRequireDefault(require("jss-rtl"));
var _styles = require("@material-ui/styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// Configure JSS
var jss = (0, _jss.create)({
  plugins: [].concat(_toConsumableArray((0, _styles.jssPreset)().plugins), [(0, _jssRtl.default)()])
});
var WobiStylesProvider = function WobiStylesProvider(props) {
  return /*#__PURE__*/_react.default.createElement(_styles.StylesProvider, {
    jss: jss
  }, props.children);
};
WobiStylesProvider.propTypes = {
  children: _propTypes.default.any
};
var _default = exports.default = WobiStylesProvider;